// LoaderModal.js
import React from 'react';
import { Modal, Backdrop, CircularProgress, Box, Typography } from '@mui/material';
import logo from '../assets/images/aiforhrhub-light.png'
const styles = {
  modal:{
    display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  },
  container:{
    top:0,
    bottom:0,
    left: 0,
    right:0,
    position:'absolute',
    background: 'linear-gradient(75deg, #572C7E, #26B3CF)',
    padding: 0,
    borderRadius: 0,
    display: 'flex',
    justifyContent:'center',
    // paddingTop:'25%',
    flexDirection: 'column',
    alignItems: 'center',
  },
  logo:{
    maxWidth: '50%',
    maxHeight: 250, // Adjust the maximum height as needed
    marginBottom: 5,
  }
}

const LoaderModal = ({ open, title}) => {


  return (
    <Modal

      sx={{ display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',}}
      open={open}
      closeAfterTransition
    
    >
     
      <Box sx={styles.container}>
        <img style={styles.logo} src={logo} alt="logo" />
        <Typography variant='button' className='text-light' sx={{fontSize:35}}>Loading...</Typography>
      <CircularProgress sx={{color:'white'}} />


      </Box>
    </Modal>
  );
};

export default LoaderModal;
